export default __webpack_public_path__ + "static/media/apple.5757c37e.svg";